import { CircularProgress, Grid2 } from '@mui/material';

import styles from './scheduleMealLoader.module.css';

const ScheduleMealLoader = ({ loading }: { loading: boolean }) => {
  if (loading) {
    <Grid2 className={styles.loader_container}>
      <CircularProgress className={styles.loader} />
    </Grid2>
  }
  return null;
};

export default ScheduleMealLoader;
